import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const ResourceCard = ({ cardData }) => {
  const {
    headline,
    description,
    isExternal,
    url,
    trackId,
    hitId,
    hitType
  } = cardData;

  const trackClick = () => {
    console.log('Clicked!');
    fetch(`/SiteSearchApi/Track/?query=${window.location.href.slice(window.location.href.indexOf('=') + 1).split('&')[0]}&hitId=${hitType}/${hitId}&trackId=${trackId}`, { method: 'GET' });
  }

  return (
    <a href={url} target={isExternal ? '_blank' : '_self'} data-trackid={trackId} data-hitid={`${hitType}/${hitId}`} onClick = {e => trackClick(e)} className="resource-card">
      <div className="resource-card__headline">
        <h4>{parse(headline)}</h4>
        <span className={`cta-decorator-v2 cta-decorator-v2--${isExternal ? 'external' : 'internal'} bg-dark`}>
          <svg viewBox={isExternal ? '0 0 19 18' : '0 0 18 18'}>
            <use xlinkHref={isExternal ? '#link-arrow-icon' : '#link-arrow-right-icon'}/>
          </svg>
        </span>
      </div>
      {description && (
        <div className="resource-card__description">
          <p>{parse(description)}</p>
        </div>
      )}
    </a>
  );
};

ResourceCard.propTypes = {
  cardData: PropTypes.object.isRequired
};

export default ResourceCard;
